/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */

import PropTypes from 'prop-types';
import React, { useLayoutEffect, useState } from 'react';
import Text from './Text';
import { Grid } from '@mui/material/index';
import { PLACEHOLDER_IMG_SRC, style } from 'constant/constants';
import { trancateText } from 'utils/utils';
import { getAllRows } from 'pages/roofSection/roofSectionUtils';

const rightHeaderTextStyle = { display: 'flex', justifyContent: 'flex-start' };

const detailHeadings = { width: '105px', textAlign: 'left'}

const styleProjectNameAndDesc = { overflow: 'hidden', width: '225px', textAlign: 'left', paddingBottom: 6};

/**
 * InvoicePDF component to generate PDF of invoice
 * @param {object} props.invoiceData - data of the invoice to be displayed in PDF
 * @returns {JSX.Element} - JSX for the invoice PDF
 */
const InvoicePDF = React.forwardRef(({ invoiceData }, ref) => {
  const [img, setImg] = useState(null);
  useLayoutEffect(() => {
    (async () => {
      // fetch image and do something
      try {
        // if URL is not of place holder image 
        if (invoiceData?.store?.logo != PLACEHOLDER_IMG_SRC)
          fetch(invoiceData?.store?.logo, { method: 'GET', mode: 'cors', cache: "no-store"})
            .then(response => response.blob())
            .then(blob => {
              const reader = new FileReader();
              reader.onloadend = () => {
                const base64data = reader.result;
                // Use `base64data` as src in img tag for PDF generation
                setImg(
                  <img
                    alt='logo'
                    id="logo-img"
                    style={{ maxWidth: 320, maxHeight: 110 }}
                    src={base64data}
                  />
                );
              };
                reader.readAsDataURL(blob);
            });
        else
            setImg( <img
              alt='logo'
              id="logo-img"
              style={{ maxWidth: 320, maxHeight: 110 }}
              src={PLACEHOLDER_IMG_SRC}
            />)
    } catch (err) {
        console.log(err);
      }
    })();
  }, [invoiceData?.store?.logo]);

  return (
    <>
      {img && (
        <div style={{ width: 720 }} ref={ref}>
          <Grid sx={{ minHeight: 900 }}>
            <div className="header">
              <div className="header-left" style={{ width: 370, wordWrap: 'break-word' }}>
                {img}
                <p className="company-name">{invoiceData?.store?.name}</p>
                <Text>{invoiceData?.store?.email}</Text>
                <Text>{trancateText(invoiceData?.store?.address, 100)}</Text>
                <Text>{invoiceData?.store?.phone}</Text>
              </div>
              <div className="header-right">
                <p className="invoice-title">ESTIMATE CONFIRMATION</p>
                <p style={rightHeaderTextStyle}>
                  <span style={detailHeadings}>Estimate No:</span> <span>{invoiceData?.invoiceNumber}</span>
                </p>
                <p style={rightHeaderTextStyle}>
                  <span style={detailHeadings}>Create Date:</span> <span>{invoiceData?.createDate}</span>
                </p>
                <p style={rightHeaderTextStyle}>
                  <span style={detailHeadings}>Project Name:</span> <span style={styleProjectNameAndDesc}>{trancateText(invoiceData?.project?.name, 100)}</span>
                </p>
                <p style={rightHeaderTextStyle}>
                  <span style={detailHeadings}>Description:</span> <span style={styleProjectNameAndDesc}>{trancateText(invoiceData?.project?.description, 100)}</span>
                </p>
              </div>
            </div>
            <Grid direction="column">
              <Text sx={{ backgroundColor: style.LIGHT.primary, color: 'white', px: 1, pb: 2 }}>
                BILL TO
              </Text>
              <Grid sx={{ px: 1, mb: 2 }}>
                <Text>{invoiceData?.billTo?.name}</Text>
                <Text>{invoiceData?.billTo?.email}</Text>
              </Grid>
            </Grid>
            <table className="table" id="pdf-table" style={{ pageBreakInside: 'auto' }}>
              <thead>
                <tr style={{ backgroundColor: style.LIGHT.primary, color: 'white', fontSize: '2vh' }}>
                  <th>ITEM</th>
                  <th>QTY</th>
                  <th>PRICE $</th>
                  <th style={{ whiteSpace: 'nowrap' }}>TOTAL $</th>
                </tr>
              </thead>
              <tbody>{getAllRows(invoiceData.items)}
                <tr style={{ marginTop: 10 }}>
                  <th colSpan="2"></th>
                  <th className="table-total">Sales Total:</th>
                  <th className="table-total">${invoiceData?.salesTotal}</th>
                </tr>
               {invoiceData?.handlingFee && <tr>
                  <th colSpan="2"></th>
                  <th className="table-total">{`Handling Fee (${invoiceData?.handlingFee}):`}</th>
                  <th className="table-total">${invoiceData?.handlingAmount}</th>
                </tr>}
                <tr>
                  <th colSpan="2"></th>
                  <th className="table-total">Tax Total:</th>
                  <th className="table-total">${invoiceData?.taxTotal}</th>
                </tr>
                <tr>
                  <th colSpan="2"></th>
                  <th className="table-total">TOTAL:</th>
                  <th className="table-total">${invoiceData?.total}</th>
                </tr>
                </tbody>
            </table>
          </Grid>
          <Grid sx={{ minHeight: 900, pageBreakBefore: 'always', fontSize: '8px', paddingRight: 2 }}>
            <br />
            <p className="paragraph">
              <p className="headers">
                <b> Distributor or Installer & TRA Snow & Sun Terms & Conditions of Sale</b>
              </p>
                Your signature authorizes the included engineering, terms, quantity, shipping information,
                seam profile, color, & price. <b>Distributor or Installer & TRA Snow & Sun does not color match.</b> We
                powder coat the materials; which is a different application than most metal, and so do not
                guarantee any color match, including but not limited to the gloss, texture, finish, or
                color. Please call for a sample of stated color above if further approval or review is
                needed.
            </p>
            <br />
            <p className="paragraph">
              <p className="headers">Terms & Conditions</p>
                All balances are due by the terms stated above. Buyer and seller agree title and ownership
                of merchandise remain solely in the seller’s name until paid in full. Buyer agrees to pay
                2% per month service charge (24% APR) if due beyond the agreed due date. Should collection
                become necessary, buyer expressly agrees to pay all costs of collection including an
                additional collection fee of up to 50% of the total amount owed.{' '}
              <b>
                Product guarantee is limited to products installed to Distributor or Installer & TRA Snow & Sun’s
                engineered specifications.
              </b>{' '}
                No cash refunds except on manager’s written approval. A twenty (20%) restocking fee will
                be applied to all stock merchandise. No returns will be accepted on custom orders. A
                returned check fee of $20.00 will apply to any returned checks.
            </p>
            <br />
            <p className="paragraph">
              <p className="headers">
                <b> Distributor or Installer & TRA SNOW AND SUN, INC.</b>
              </p>
              <p className="headers">Overpayment/Credit Policy</p>
              <p>
                Credit memos and refunds are processed separately from invoices. Once credit memos or
                overpayments have been processed, they will be applied to the next invoice issued to the
                customer. If no further purchases are made by the customer, the customer has 90 days to
                request a refund check. After 90 days, the overpayment will become a credit to the
                customer’s account. A credit will be held on the customer’s account up to 365 days (1
                year). If a credit memo has been on a customer’s account for past 365 days (1 year), the
                credit memo will be removed from the customer’s account and written off. It is the
                customer’s responsibility to manage any credit/refunds on their account.{' '}
                <b>
                Distributor or Installer & TRA Snow & Sun assumes no responsibility in maintaining notification of
                such credit/refund outside of monthly statements. 
                </b>{' '}
                All returns must be accompanied by a valid receipt. 
                Merchandise must be in like new condition and in complete original packaging. 
                Return period: 30 days from original invoice receipt.
              </p>
            </p>
            <br />
            <p className="paragraph">
              <p className="headers">Sales & Use Tax</p>
              <p>
                Consumer hereby acknowledges and agrees to pay for any all sales and use taxes payable
                to local or state jurisdictions outside the State of Utah.{' '}
                <b>
                  Distributor or Installer & TRA Snow & Sun will not be held liable for any taxes required by any
                  goods purchased outside the State of Utah.
                </b>
              </p>
            </p>
            <br />
            <p className="paragraph">
              <p className="headers">Inspection Upon Receipt</p>
              <p>
                Buyer shall inspect all shipments before unloading. If visible damage, shifting of
                lading or shortages is detected, Buyer shall note the damage or shortage on the
                carrier’s copy of the delivery receipt and give notice thereof to Seller within 24
                hours. Failure of Buyer to strictly comply with this section shall be deemed to be a
                waiver of Buyer of any claims it may have against Seller for shortages or damage in
                transit.
              </p>
            </p>
            <br />
            <p className="paragraph">
              <p className="headers">Shipping Terms & Conditions</p>
              <p style={{ paddingBottom: '20px' }}>
                Shipping and services charges are determined by the weight and size of items, number of
                packages, and delivery zip code. Standard shipping and service charges are for delivery
                to a commercial location with a dock or forklift access. Additional charges will apply
                for residential deliveries, use of forklift gate, and assistance with unloading. The
                final charge for shipping will appear at the end of your transaction. What additional
                fees may apply? There may be circumstances that require additional payment by you if the
                conditions mentioned have not been met, or you require special services outside our
                standard delivery. (For example, if you need a specified time window, your address is
                not tractor trailer accessible, you were not available for your scheduled delivery,
                delivery not made due to unsafe conditions, not indicating missing pieces on the
                delivery note, etc.) You will be invoiced immediately for these items, and the invoice
                is due upon receipt. All additional shipping and service items that are known of before
                shipment will be charged a lesser amount.
              </p>
            </p>
          </Grid>
        </div>
      )}
    </>
  );
});

InvoicePDF.propTypes = {
  invoiceData: PropTypes.object
};

export default InvoicePDF;
